// extracted by mini-css-extract-plugin
module.exports = {"medium_title":"MediumTitle_medium_title__X_nVT"};